module.exports = __webpack_public_path__ + "img/icon_bed.95e244c7.svg";